import { useEffect } from "react";
function useOnClickOutside(ref, handler, extraArrDependencies) {
    useEffect(()=>{
        const listener = (event)=>{
            if (!ref.current || ref.current.contains(event.target)) return;
            handler(event);
        };
        if ("u" > typeof document) {
            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);
        }
        return ()=>{
            if ("u" > typeof document) {
                document.removeEventListener('mousedown', listener);
                document.removeEventListener('touchstart', listener);
            }
        };
    }, [
        ref,
        handler,
        ...extraArrDependencies || []
    ]);
}
const src_useOnClickOutside = useOnClickOutside;
export default src_useOnClickOutside;
